import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface BannerActionButtonProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  isSelected?: boolean;
}

export function BannerActionButton({
  icon,
  label,
  onClick,
  isSelected = false,
}: BannerActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-1 rounded-[88px] p-2 text-sm transition-colors",
        isSelected
          ? "bg-[#fdfcf9] text-[#1f1e1d]"
          : "text-[#58534c] hover:bg-[#fdfcf9]",
      )}
    >
      <span className="flex h-3 w-3 items-center justify-center">{icon}</span>
      <span className="whitespace-nowrap px-0.5 text-[14px] leading-[20px]">
        {label}
      </span>
    </button>
  );
}
